/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_timetable.js                                                                         */
/**********************************************************************************************************************/
/* Controller.Timetable */

/**
 * @class this.Controller.Timetable
 */
HafasWebapp.prototype.Controller.Timetable = {

  /** Da das Timetable-Feature z. Zt. nicht über ein Formular zu öffnen ist, gibt es keine Index-Funktion **/

  additionalInstances: {},
  result: {},
  mapContent: {polylines: [], locations: []},
  selectedInput: Hafas.Config.Timetable.inputOnForm,
  selectedLocation: null,

  index: function () {
    Hafas.ps.pub('/app/events/closeResults', [{}]);
    Hafas.ps.pub('/GUI/results/details/hide', [{}]);
    if (this.Controller.Timetable.selectedInput === "stop") {
      // initial soll eine Haltestelle ausgewählt werden
      Hafas.bind(this.Controller.Timetable.initStopForm, this)();
    } else if (this.Controller.Timetable.selectedInput === "line") {
      // initial soll eine Linie ausgewählt werden
      Hafas.bind(this.Controller.Timetable.initLineForm, this)();
    }
  },

  initStopForm: function (callback) {
    var focusSelector = Hafas.Util.gui.getFocusElementSelector();

    var me = this;
    var controller = me.Controller.Timetable;
    Hafas.bind(me.Controller.Timetable.setSelectedInput, me)("stop");
    var model = {
      toggleInputOnForm: Hafas.Config.Timetable.toggleInputOnForm,
      selectInput: "stop"
    };

    var useFavorites = true;

    model.locationFavorites = useFavorites ? me.Controller.Favorites.instance.getData("S") : null;

    if (Hafas.Modules.History)
      Hafas.Modules.History.addData("Timetable", "index", {});

    if (Hafas.Config.debug.showDataModel) {
      console.log('+++ Timetable.index +++ DEBUG Model +++', model)
    }

    var inputValue = me.Controller.Timetable.instance.getLocation("S");
    model.value = inputValue.name || "";

    controller.loadTemplates(function () {
      Hafas("#" + me.formContainer).innerHTML = Hafas.Modules.Render.renderTemplate("Timetable_TplIndex", model);
      Hafas.bind(me.Controller.Timetable.createStopSuggest, me)();

      // If available (e.g. with browser back) render the previous stop, line and direction
      Hafas.bind(me.Controller.Timetable.processStopInput, me)({loc: me.Controller.Timetable.instance.getLocation("S")});


      // GUI/form/show muss vor den nachfolgenden aufgerufen werden, da bei HistoryBack sonst favorites/update mit
      // simplifyLineSignets keinen Sinn macht und renderDone auch nicht, da noch kein Formular angezeigt wurde
      Hafas.ps.pub('/GUI/form/show', [{}]);
      Hafas.ps.pub('/favorites/update');
      Hafas.ps.pub('/app/events/renderDone');
      Hafas.ps.pub('/app/events/resize');
      Hafas.ps.pub('/app/contextLoaded/' + me.appContext);

      if(typeof callback == 'function'){
        callback();
      }
    });

    if (!focusSelector || Hafas(focusSelector).clientHeight === 0) {
      // Focus first element
      focusSelector = Hafas.Util.node.getPath(Hafas.Util.node.getFirstVisibleAndFocusableElement(Hafas('#DocumentFormInput')));
    }
    Hafas.Util.gui.restoreFocus(focusSelector);
  },

  initLineForm: function (callback) {
    var focusSelector = Hafas.Util.gui.getFocusElementSelector();

    var me = this;
    var controller = me.Controller.Timetable;
    Hafas.bind(me.Controller.Timetable.setSelectedInput, me)("line");
    var model = {
      line: {},
      toggleInputOnForm: Hafas.Config.Timetable.toggleInputOnForm,
      selectInput: "line"
    };

    var lineResult = Hafas.bind(this.Controller.Timetable.getLineDetailsResult, this)();
    if (lineResult != null) {
      model.line.value = lineResult.prodResolved.name;
    }

    if (Hafas.Modules.History)
      Hafas.Modules.History.addData("Timetable", "index", {});

    if (Hafas.Config.debug.showDataModel) {
      console.log('+++ Timetable.index +++ DEBUG Model +++', model)
    }

    controller.loadTemplates(function () {
      Hafas("#" + me.formContainer).innerHTML = Hafas.Modules.Render.renderTemplate("Timetable_TplIndex", model);
      Hafas.bind(me.Controller.Timetable.createLineSuggest, me)();

      // Falls vorhanden (zB bei Browser-Back) die vorherige Linie, Richtung und Haltestellenliste rendern
      if (lineResult != null) {
        // Linie explizit setzen, im Fall von Übergabe der Linien-ID als URL Parameter + browser-back
        Hafas.bind(me.Controller.Timetable.setLineMatchResult, me)(lineResult);
        var direction = Hafas.bind(me.Controller.Timetable.getDirectionText, me)();
        Hafas.bind(me.Controller.Timetable.renderSelectedLine, me)({direction: direction});
        Hafas.bind(me.Controller.Timetable.setSelectedDirectionStops, me)();
      }

      Hafas.ps.pub('/GUI/form/show', [{}]);
      Hafas.ps.pub('/favorites/update');
      Hafas.ps.pub('/app/events/renderDone');
      Hafas.ps.pub('/app/events/resize');
      Hafas.ps.pub('/app/contextLoaded/' + me.appContext);

      if(typeof callback == 'function'){
        callback();
      }
    });

    if (!focusSelector || Hafas(focusSelector).clientHeight === 0) {
      // Focus first element
      focusSelector = Hafas.Util.node.getPath(Hafas.Util.node.getFirstVisibleAndFocusableElement(Hafas('#DocumentFormInput')));
    }
    Hafas.Util.gui.restoreFocus(focusSelector);
  },

  initStopFormFromSQInfo: function() {
    var _me = this;
    // Callback ist notwendig, falls Template noch nicht geladen wurde und Ajax länger braucht, wodurch das Input-Feld im Nachgang nicht gefunden wird
    Hafas.bind(_me.Controller.Timetable.initStopForm, _me)(Hafas.bind(function() {
      var timetableStopInput = Hafas('#TimetableStopInput');
      if (timetableStopInput && _me.Controller.Timetable.selectedLocation) {
        timetableStopInput.value = _me.Controller.Timetable.selectedLocation.name;
      }
      Hafas.bind(_me.Controller.Timetable.processStopInput, _me)({loc: _me.Controller.Timetable.selectedLocation});
    }, this));
  },

  loadTemplates: function (callback) {
    Hafas.Modules.Loader.loadTemplateFiles([
      'timetable.index.html',
      'linesearch.index.html',
      'linesearch.suggest.html',
      'linesearch.atoms.html'
    ], Hafas.bind(function () {
      callback();
    }, this));
  },

  submitTimetableForm: function () {
    var lineResult = this.Controller.Timetable.currentLineResult;
    if (lineResult != null) {
      Hafas.ps.pub('/timetable/search', [{}]);
    } else {
      if (this.Controller.Timetable.selectedInput === "stop") {
        // initial soll eine Haltestelle ausgewählt werden
        var location = this.Controller.Timetable.instance.getLocation("S");
        var input = this.Controller.Timetable.inpStation;
        var inputText = input.getInputText();
        var textLength = inputText.length;
        if (textLength === 0) {
          // No text in input, but a lid to resolve the name
          if (location && Hafas.Util.location.isValid(location)) {
            input.validateLocation(true);
          } else {
            this.Controller.Timetable.instance.setLocation({lid: "", name: "", type: "S"}, "S");
          }
        }
        if ((textLength > 0) && (location == null || inputText != location.name)) {
          input.validateLocation(true);
        }
      } else if (this.Controller.Timetable.selectedInput === "line") {
        // initial soll eine Linie ausgewählt werden
        var line = this.Controller.Timetable.instance.getLineId();
        var input = this.Controller.Timetable.lineSuggest;
        var inputText = input.getInputText();
        var textLength = inputText.length;
        if (textLength === 0) {
          this.Controller.Timetable.instance.setLineId("");
        }
        if (textLength > 0 && (line == null || line === "")) {
          input.validateLocation(true);
        }
      }
    }
  },

  /***********************************************************************************************************
   * Linie wird zuerst gesucht *
   ***********************************************************************************************************/

  createLineSuggest: function () {
    var me = this;
    me.Controller.Timetable.lineSuggest = Hafas.Core.newType("hafasSuggest", {
      input: "HFS_searchTimetableLineInput",
      config: {minChar: 0},
      suggestMode: 'LineSearch',
      renderTpl: 'LineSearch_TplLineSuggest',
      useFunctionButtons: false,
      onSelect: Hafas.bind(function (line) {
        Hafas.bind(me.Controller.Timetable.processLineInput, me)({line: line});
      }, this)
    });

    // override default behaviour of suggest, because LineSearch is not using locations within suggest
    var overrides = me.Controller.Timetable.lineSuggest.overrides;

    overrides.buildRequestObject = me.Controller.Timetable.linesearch.buildSearchLinesRequestObject;
    overrides.transformHCIData = me.Controller.Timetable.linesearch.transformHCILineSearchData;
    overrides.customMergeFunction = function (_1, _2, sObj) {
      var list = sObj.suggestList;

      // only if there are no suggests, show history and favorites
      if (list.length === 0)
        list = list.concat(sObj.favoriteList).concat(sObj.historyList);

      return list;
    };

    overrides.getHistoryList = function (favoriteData) {
      return favoriteData.linesHistory;
    };
    overrides.getFavoritesList = function (favoriteData) {
      return favoriteData.lines;
    };
    overrides.getTopList = function () {
      return [];
    };
  },

  processLineInput: function (params) {
    // We need to clear any direction that has been set before, otherwise it will be used as a journey filter in a potential different line
    this.Controller.Timetable.instance.setLocation(null, "S");


    Hafas.ps.pub('/gui/form/toggle/loading', [{toggle: true}]);
    Hafas.ps.pub('/linesearch/closePopover',[]);
    var me = this;
    var line = params.line;
    Hafas.bind(me.Controller.Timetable.setLineMatchResult, me)(line);
    this.Controller.Timetable.instance.setLineId(line.lineId);
    var deleteButtonEle = Hafas("[data-timetable-field='delete']");
    if (deleteButtonEle) {
      Hafas.Util.gui.setVisibility(deleteButtonEle, true);
    }
    // LineDetails für diese Linie abrufen und Haltestellenliste für Direction rendern
    var data = {
      lineId: me.Controller.Timetable.instance.getLineId(),
      callback: function (result) {
        var model = {
          lid: "",
          name: "",
          type: "S"
        };
        Hafas.ps.pub('/timetable/setLocation', [model, "S"]);
        if (Hafas.Config.Favorites.addLocationOnSuggest) {
          Hafas.ps.pub('/favorites/addLineToHistory', [result]);
        }
        Hafas.bind(me.Controller.Timetable.setLineDetailsResult, me)(result[0]);
        Hafas.bind(me.Controller.Timetable.renderSelectedLine, me)({});
      }
    };

    var hitSearch = true;
    if(typeof params.hitSearch !== 'undefined')
      hitSearch = params.hitSearch;
    if(hitSearch)
      var deleteButtonEle = Hafas("[data-timetable-field='delete']");
    if (deleteButtonEle) {
      Hafas.Util.gui.setVisibility(deleteButtonEle, true);
    }
      me.Controller.Timetable.instance.searchLineDetails(data);

  },

  renderSelectedLine: function (params) {
    // console.log("+++ renderSelectedLine +++",params);
    var me = this;
    var line = Hafas.bind(this.Controller.Timetable.getLineDetailsResult, this)();
    if (!line) {
      return;
    }
    var dirText;
    var dirFlag;
    // Wenn eine Richtung übergeben wurde, entsprechend dirText & dirFlag setzen
    if ((typeof params != "undefined") && (params.direction)) {
      dirText = params.direction;
      if(line.directions.length !== 0 ) {
        for(var dIdx = 0; dIdx < line.directions.length; dIdx++) {
          if(line.directions[dIdx].txt == dirText) {
            dirFlag = line.directions[dIdx].flg;
          }
        }
      }
      // wenn keine Richtung übergeben wurde, erste Richtung aus der Liste vorbelegen
    } else {
      if(line.directions.length !== 0 ) {
        dirText = line.directions[0].txt;
        dirFlag = line.directions[0].flg;
      }
    }
    Hafas.bind(this.Controller.Timetable.setDirectionText, this)(dirText);
    this.Controller.Timetable.instance.setDirection(dirText);
    if(dirFlag !== undefined) {
      this.Controller.Timetable.instance.setDirectionFlag(dirFlag);
    }

    var newVal = line.prodResolved.name;
    Hafas('#HFS_searchTimetableLineInput').value = newVal;

    var label = Hafas('label[for="HFS_searchTimetableLineInput"]');
    Hafas.Modules.a11y.Announce.polite(Hafas.Modules.i18n.get('a11y.announce.t_N_ElementTextChanged', {
      element: label.textContent,
      text: newVal
    }));
    Hafas.Modules.Render.render({
      target: Hafas("#HFS_LineDirectionWrapper"),
      template: 'Timetable_TplIndex_DirectionSelect',
      model: {
        line: line,
        selectedDirection: dirText,
        label: Hafas.Modules.i18n.get('common.label.t_N_Direction'),
        id: "HFS_TimetableLineDirSelectionLine"
      },
    }, Hafas.bind(function () {
      Hafas.Util.gui.setVisibility(Hafas("#HFS_LineDirectionWrapper"), true);
      Hafas('#HFS_TimetableSubmit').disabled = '';
      var callback = function (data) {
        Hafas.bind(me.Controller.Timetable.setDirectionText, me)(data.value);
        me.Controller.Timetable.instance.setDirectionFlag(data.dirFlg);

        // Hafas.ps.pub('/timetable/set/stops', [params.value]);
        Hafas.bind(me.Controller.Timetable.setSelectedDirectionStops, me)();
      };
      if (me.Controller.Timetable.lineDirSelectBox) me.Controller.Timetable.lineDirSelectBox.destroy();
      me.Controller.Timetable.lineDirSelectBox = Hafas.Core.newType('HafasSelectBox', {
        holder: 'HFS_TimetableLineDirSelection_Holder',
        callback: callback
      }).initiate();
      Hafas.ps.pub('/app/events/resize');
    }, this));
    Hafas.bind(me.Controller.Timetable.setSelectedDirectionStops, me)();
  },

  setSelectedDirectionStops: function () {
    var direction = Hafas.bind(this.Controller.Timetable.getDirectionText, this)();
    var jnyResult = Hafas.bind(this.Controller.Timetable.getDirectionJourney, this)({direction: direction});
    var locList = jnyResult.resolvedLocList;
    var selectedLocation = this.Controller.Timetable.instance.getLocation('S');
    var model = {
      label: Hafas.Modules.i18n.get('Timetable.t_N_searchLabelStop'),
      locList: locList,
      selectedLocation: ""
    };
    // Nochmal prüfen, ob die auszuwählende Haltestelle wirklich in der Liste vorhanden ist
    var hasLocation = false;
    for(var i = 0; i < locList.length; i++) {
      if(locList[i].name == selectedLocation.name) {
        hasLocation = true;
        break;
      }
    }
    if (hasLocation && selectedLocation.name) {
      model.selectedLocation = selectedLocation.name;
    }
    Hafas.Modules.Render.render({
      target: Hafas("#HFS_LineStopWrapper"),
      template: 'Timetable_TplIndex_StopSelect',
      model: model,
    }, Hafas.bind(function () {
      Hafas.Util.gui.setVisibility(Hafas("#HFS_LineStopWrapper"), true);
      var callback = function (params) {
        var selectedOptionId = params.trigger.getAttribute('aria-activedescendant');
        var optionWrapperData = Hafas("#HFS_TimetableLineStopSelection_Holder #" + selectedOptionId).firstElementChild.dataset;
        var locKey = optionWrapperData.lockey;
        var location = Hafas.Modules.Render.objectKeeper.get(locKey);
        Hafas.ps.pub('/timetable/setLocation', [location, "S"]);
      };
      if (this.Controller.Timetable.lineStopSelectBox) {
        this.Controller.Timetable.lineStopSelectBox.destroy();
      }
      this.Controller.Timetable.lineStopSelectBox = Hafas.Core.newType('HafasSelectBox', {
        holder: 'HFS_TimetableLineStopSelection_Holder',
        callback: callback
      }).initiate();
      Hafas.Util.gui.setVisibility(Hafas("#HFS_TimetableSubmitWrapper"), true);
      // Hafas.Util.gui.setVisibility(Hafas("#HFS_TimetableSubmitWrapper"), true);
      Hafas.Util.gui.setVisibility(Hafas("#HFS_TimetableIndex_Overlay"), false);
      Hafas.ps.pub('/app/events/resize');
    }, this));
  },

  toggleLineFavorite: function (lineId, source, add) {
    var line = Hafas.bind(this.Controller.Timetable.getLineDetailsResult, this)();
    if (add)
      if (source === 'history')
        Hafas.ps.pub('/favorites/addLineFromHist', [lineId]);
      else
        Hafas.ps.pub('/favorites/addLineToFav', [line]);
    else
      Hafas.ps.pub('/favorites/removeLine', [lineId]);
  },

  saveLineAsFavorite: function (lineId, source) {
    Hafas.bind(this.Controller.Timetable.toggleLineFavorite, this)(lineId, source, true);
  },

  deleteLineFromFavorite: function (lineId, source) {
    Hafas.bind(this.Controller.Timetable.toggleLineFavorite, this)(lineId, source, false);
  },

  deleteLineInput: function (deleteFromStorage) {
    Hafas.bind(this.Controller.Timetable.GUI.form.toggleFormSelectboxes, this)({
      idL: ['HFS_LineDirectionWrapper', 'HFS_LineStopWrapper'],
      show: false
    });
    Hafas.bind(this.Controller.Timetable.setLineMatchResult, this)(null);
    Hafas.bind(this.Controller.Timetable.setLineDetailsResult, this)(null);
    Hafas.bind(this.Controller.Timetable.setDirectionText, this)("");
    this.Controller.Timetable.instance.setLineId("");
    var model = {
      lid: "",
      name: "",
      type: "S"
    };
    Hafas.ps.pub('/timetable/setLocation', [model, "S"]);
    if (Hafas('#HFS_searchTimetableLineInput')) {
      Hafas('#HFS_searchTimetableLineInput').value = "";
    }
    // Remove line input from session storage
    if (deleteFromStorage === true && this.Controller.Timetable.lineSuggest !== undefined) {
      this.Controller.Timetable.lineSuggest.resetLocation();
    }
    var deleteButtonEle = Hafas("[data-timetable-field='delete']");
    if (deleteButtonEle) {
      Hafas.Util.gui.setVisibility(deleteButtonEle, false);
    }
    if (Hafas("#HFS_LineDirectionWrapper")) {
      Hafas("#HFS_LineDirectionWrapper").innerHTML = Hafas.Modules.Render.renderTemplate("Timetable_TplIndex_Preview_Direction", {});

    }
    if (Hafas("#HFS_LineStopWrapper")) {
      Hafas("#HFS_LineStopWrapper").innerHTML = Hafas.Modules.Render.renderTemplate("Timetable_TplIndex_Preview_Stop", {});
    }
    Hafas.Util.gui.setVisibility(Hafas("#HFS_TimetableSubmitWrapper"), false);
    Hafas.ps.pub('/app/events/resize');
  },

  /***********************************************************************************************************/
  /** Haltestelle wird zuerst gesucht **/
  /***********************************************************************************************************/

  createStopSuggest: function () {
    var me = this;
    var tmpLoc = me.Controller.Timetable.instance.getLocation("");
    me.Controller.Timetable.inpStation = Hafas.Core.newType('hafasSuggest',
      {
        loc: "TimetableStopInput",
        config: {
          suggestType: "S",
          useNearLocation: true
        },
        type: "S"
      });

    if (tmpLoc != null && tmpLoc.name) {
      me.Controller.Timetable.inpStation.setLocation(tmpLoc);
    }
  },

  processStopInput: function (params) {
    var me = this;

    var location = params.loc;
    Hafas.ps.pub('/timetable/setLocation', [location, "S"]);

    Hafas.bind(me.Controller.Timetable.validate, me)({params: params, model: location}, Hafas.bind(function (products) {

      var formContainer = Hafas("#" + me.formContainer);
      me.Controller.Timetable.currentForm = Hafas('#HFS_TimetableSearch', false, formContainer);
      var stopFormValidation = Hafas.Core.newType("hafasValidation", {
        checkFormOnInit: false,
        form: me.Controller.Timetable.currentForm
      });

      // override default behaviour of suggest, because LineSearch is not using locations within suggest
      var overrides = stopFormValidation.overrides;

      overrides.checkForm = function () {
        var instance = stopFormValidation;
        instance.resetFields();

        var i = 0,
          len = instance.elements.length;

        for (i; i < len; i++) {
          var el = instance.elements[i];
          if (el.getAttribute('required')) {
            if (products.length == 0) {
              instance.valid = false;
              instance.showError(el, 'noResults');
            }
          }
        }
      };

      stopFormValidation.checkForm();

      if (stopFormValidation.valid) {
        Hafas.ps.pub('/gui/form/toggle/loading', [{toggle: true}]);
        var result = {location: location, products: products};
        var deleteButtonEle = Hafas("[data-timetable-field='delete']");
        if (deleteButtonEle) {
          Hafas.Util.gui.setVisibility(deleteButtonEle, true);
        }
        Hafas.bind(me.Controller.Timetable.setLocationInfo, me)(result);
        Hafas.bind(me.Controller.Timetable.renderLineSelect, me)({});
      } else {
        Hafas.ps.pub('/app/events/resize');
      }

    }));

  },

  renderLineSelect: function (params) {
    var me = this;
    var model = Hafas.bind(me.Controller.Timetable.getLocationInfo, me)();
    var selectedLine = me.Controller.Timetable.instance.getLineId();
    var lineExistsInProducts = model.products?.some(product => {
      // Check if any product has the same line ID as the line that was saved in the module
      return product?.prodCtx?.lineId === selectedLine;
    });
    if (params && params.selectedLine) {
      selectedLine = params.selectedLine;
    } else if (!selectedLine || lineExistsInProducts === false) {
      selectedLine = model.products[0].prodCtx.lineId;
    }
    model.selectedLine = selectedLine;
    model.label = Hafas.Modules.i18n.get('Timetable.t_N_searchLabelLine');
    var label = Hafas('label[for="TimetableStopInput"]');
    Hafas.Modules.a11y.Announce.polite(Hafas.Modules.i18n.get('a11y.announce.t_N_ElementTextChanged', {
      element: label.textContent,
      text: model.location.name
    }));

    Hafas.Modules.Render.render({
      target: Hafas("#HFS_LineSelectionWrapper"),
      template: 'Timetable_TplIndex_LineSelect',
      model: model,
    }, Hafas.bind(function () {
      Hafas.Util.gui.setVisibility(Hafas("#HFS_LineSelectionWrapper"), true);
      var callback = function (data) {
        // LineDetails für diese Linie abrufen und Haltestellenliste für Direction rendern
        me.Controller.Timetable.instance.setLineId(data.value);
        var model = {
          lineId: data.value,
          callback: function (result) {
            Hafas.bind(me.Controller.Timetable.setLineDetailsResult, me)(result[0]);
            Hafas.bind(me.Controller.Timetable.renderDirectionSelect, me)();
          }
        };
        me.Controller.Timetable.instance.searchLineDetails(model);
      };
      if (me.Controller.Timetable.lineSelectBox) me.Controller.Timetable.lineSelectBox.destroy();
      me.Controller.Timetable.lineSelectBox = Hafas.Core.newType('HafasSelectBox', {
        holder: 'HFS_TimetableLineSelection_Holder',
        callback: callback
      }).initiate();
      me.Controller.Timetable.instance.setLineId(selectedLine);
      var model = {
        lineId: selectedLine,
        callback: function (result) {
          Hafas.bind(me.Controller.Timetable.setLineDetailsResult, me)(result[0]);
          Hafas.bind(me.Controller.Timetable.renderDirectionSelect, me)(params);
        }
      };
      me.Controller.Timetable.instance.searchLineDetails(model);
      Hafas.ps.pub('/app/events/resize');
    }, this));
  },

  renderDirectionSelect: function (params) {
    if (this.Controller.Timetable.selectedInput !== "stop") {
      // Only go on with rendering if we are still in stop view. If user has switched to lines while loading, we will end up rendering the element in the wrong view
      return;
    }
    var me = this;
    var line = Hafas.bind(this.Controller.Timetable.getLineDetailsResult, this)();
    // select first direction *****************************/
    var dirText;
    if(line.directions.length !== 0) dirText = line.directions[0].txt;
    if ((typeof params != "undefined") && (params.direction)) {
      dirText = params.direction;
    }
    Hafas.bind(this.Controller.Timetable.setDirectionText, this)(dirText);
    this.Controller.Timetable.instance.setDirection(dirText);

    this.Controller.Timetable.instance.setLineId(line.lineId);
    Hafas.Modules.Render.render({
      target: Hafas("#HFS_LineDirectionWrapper"),
      template: 'Timetable_TplIndex_DirectionSelect',
      model: {
        line: line,
        selectedDirection: dirText,
        label: Hafas.Modules.i18n.get('common.label.t_N_Direction'),
        id: "HFS_TimetableLineDirSelectionStop"
      },
    }, Hafas.bind(function () {
      Hafas.Util.gui.setVisibility(Hafas("#HFS_LineDirectionWrapper"), true);
      var callback = function (data) {
        Hafas.bind(me.Controller.Timetable.setDirectionText, me)(data.value);
      };
      if (me.Controller.Timetable.lineDirSelectBox) me.Controller.Timetable.lineDirSelectBox.destroy();
      me.Controller.Timetable.lineDirSelectBox = Hafas.Core.newType('HafasSelectBox', {
        holder: 'HFS_TimetableLineDirSelection_Holder',
        callback: callback
      }).initiate();
      Hafas('#HFS_TimetableSubmit').disabled = '';
      Hafas.Util.gui.setVisibility(Hafas("#HFS_TimetableSubmitWrapper"), true);
      Hafas.Util.gui.setVisibility(Hafas("#HFS_TimetableIndex_Overlay"), false);
      Hafas.ps.pub('/app/events/resize');
    }, this));
  },

  processFavoritesData: function (params) {
    var tempFavData = Hafas.Core.clone(params);
    var processL = ['lines', 'linesHistory'];
    for (var i = 0; i < processL.length; i++) {
      var currentObj = processL[i];
      var currentList = params[currentObj];
      var j = currentList.length;
      while (j--) {
        if (!currentList[j].hasOwnProperty('directions')) {
          tempFavData[currentObj].splice(j, 1);
        }
      }
    }
    return tempFavData;
  },

  addLocationToHistory: function (params) {
    var suggestInstance = Hafas.Modules.Suggest.getSuggestInstanceById('TimetableStopInput');
    if (suggestInstance !== null) {
      // wenn die Location nicht aus der SuggestList zur History hinzugef?gt werden soll, wird sie hier hinzugef?gt
      var location = this.Controller.Timetable.instance.getLocation("S");
      if (params.location) {
        location = params.location;
      }
      // location zu Verlauf hinzuf?gen
      this.Controller.Favorites.instance.addLocation(location, 'History');
    }
  },

  deleteStopInput: function (deleteFromStorage) {
    Hafas.bind(this.Controller.Timetable.GUI.form.toggleFormSelectboxes, this)({
      idL: ['HFS_LineSelectionWrapper', 'HFS_LineDirectionWrapper'],
      show: false
    });
    Hafas.bind(this.Controller.Timetable.setLineDetailsResult, this)(null);
    Hafas.bind(this.Controller.Timetable.setLocationInfo, this)(null);
    Hafas.bind(this.Controller.Timetable.setDirectionText, this)("");
    this.Controller.Timetable.instance.setLineId("");
    var model = {
      lid: "",
      name: ""
    };
    Hafas.ps.pub('/timetable/setLocation', [model, ""]);
    Hafas.ps.pub('/timetable/setLocation', [model, "S"]);
    if (Hafas('#TimetableStopInput')) {
      Hafas('#TimetableStopInput').value = "";
    }
    // Remove station input from session storage
    if (deleteFromStorage === true && this.Controller.Timetable.inpStation !== undefined) {
      this.Controller.Timetable.inpStation.resetLocation();
    }
    var deleteButtonEle = Hafas("[data-timetable-field='delete']");
    if (deleteButtonEle) {
      Hafas.Util.gui.setVisibility(deleteButtonEle, false);
    }
    if (Hafas("#HFS_LineSelectionWrapper")) {
      Hafas("#HFS_LineSelectionWrapper").innerHTML = Hafas.Modules.Render.renderTemplate("Timetable_TplIndex_Preview_Line", {});
    }
    // Hafas("#HFS_TimetableSubmit").setAttribute("disabled", "disabled");
    Hafas.Util.gui.setVisibility(Hafas("#HFS_TimetableSubmitWrapper"), false);
    Hafas.ps.pub('/app/events/resize');
  },

  validate: function (valParams, callback) {
    var me = this;
    var params = valParams.params;
    var model = valParams.model;

    // Products aren't reliable from LocMatch location object, get full list via locDetails request
    var locDtlCallback = function (result) {
      this.callback = callback;
      var products = result.svcResL[0].res.locL[0].productRefList;
      // Transform locations to only keep those products with a line id
      var productsResolved = me.Controller.Timetable.instance.transformProductsResult({products: products});
      this.callback(productsResolved);
    };
    Hafas.Util.location.getLocDetails(model, locDtlCallback);

  },

  /***********************************************************************************************************/
  /** Ergebnisdarstellung **/
  /***********************************************************************************************************/

  // Laden der Richtungs-Überschrift und Location-List
  showResultOverview: function (params) {

    // console.log("+++ showResultOverview +++", params);
    var me = this;
    var model = {};
    var controller = me.Controller.Timetable;

    var dirText = Hafas.bind(controller.getDirectionText, me)();
    var result = null;
    if (params?.result) {
      result = params[0];
    } else {
      result = Hafas.bind(controller.getLineDetailsResult, this)();
    }
    var journey = Hafas.bind(controller.getDirectionJourney, this)({direction: dirText});
    var locList = journey.resolvedLocList;
    var lineList = controller.instance.getLineList();

    if (Hafas.Modules.History) {
      Hafas.Modules.History.addOrUpdateData("Timetable", "result", {
        additionalContext: 'Timetable',
        lineId           : result.lineId,
        dirText          : dirText
      });
    }

    if (!Hafas.Config.Favorites.addLocationOnSuggest && (Hafas.bind(controller.getSelectedInput, me)() == "stop")) {
      Hafas.bind(controller.addLocationToHistory, me)({});
    }

    if (!Hafas.Config.Favorites.addLocationOnSuggest && (Hafas.bind(controller.getSelectedInput, me)() == "line")) {
      Hafas.ps.pub('/favorites/addLineToHistory', [result]);
    }

    var mapModel = {
      product: result.prodResolved,
      stopList: locList
    };
    Hafas.bind(controller.setProduct, me)(mapModel.product);
    Hafas.bind(controller.drawLineToMap, me)(mapModel);

    if (lineList.length > 0) {
      model.line = lineList[0];
    } else {
      model.line = {};
    }
    model.line.prodResolved = result.prodResolved;
    model.line.lineId = result.lineId;
    model.line.locList = locList;
    model.line.dirText = dirText;

    if (Hafas.Config.Timetable.preLoadTimetable) {
      model.line.selectedLocation = Hafas.bind(this.Controller.Timetable.setSelectedLocation, this)(journey, params);
    }

    model.locList = locList;
    var lastLocation = locList[locList.length - 1];
    // model.line.selectBox = controller.getSelectBoxModel(locList);
    controller.instance.setLocation(lastLocation, "Z");
    // Hafas.bind(controller.setLine, me)(model.line);
    Hafas.Modules.Render.render({
      file: 'timetable.result.html',
      target: 'Timetable_ResultDetail',
      template: 'Timetable_TplResult',
      model: model
    }, Hafas.bind(function (html) {
      // close all open tabs
      Hafas.ps.pub('/GUI/tabs/closeAll');
      Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
      Hafas.ps.pub('/GUI/results/details/show', [{context: 'Timetable'}]);
      Hafas.ps.pub('/app/events/resize');

      // Infine Loading Bar anzeigen
      var loaderHtml = Hafas.Modules.Render.renderTemplate("Common_AtomTplLoaderBarInfinite", {id: "HFS_Timetable_OverviewLoader"});
      Hafas('#HFS_TimetableTab_Loader_0').insertAdjacentHTML('afterbegin', loaderHtml);

      if (model.line) {
        // Selectbox für die Auswahl von Stationen initialisieren
        var selectBoxCallback = function (data) {
          Hafas.Util.gui.setVisibility(Hafas("[data-overlay-target='loader_schedules']"), true);
          var selectedOptionId = data.trigger.getAttribute('aria-activedescendant');
          var optionWrapperData = Hafas("#HFS_TimetableStationSelectBoxHolder #" + selectedOptionId).firstElementChild.dataset;
          var locKey = optionWrapperData.lockey;
          var location = Hafas.Modules.Render.objectKeeper.get(locKey);
          Hafas.ps.pub('/timetable/result/load', [{location: location}]);
        };
        Hafas.Core.newType('HafasSelectBox', {
          holder: 'HFS_TimetableStationSelectBoxHolder',
          callback: selectBoxCallback
        }).initiate();
        if (Hafas.Config.Timetable.preLoadTimetable && model.line.selectedLocation?.hasOwnProperty('extId')) {
          Hafas.ps.pub('/timetable/result/load', [{location: model.line.selectedLocation}]);
        }
      }
      // hide form
      Hafas.ps.pub('/GUI/form/hide', [{appcontext: 'LineSearch'}]);

      // Focus back button
      Hafas.Util.gui.focusFirstElement('#HFS_DocumentDetailOverview');
    }, this));
  },

  setSelectedLocation: function (journey, params) {
    // Preload the departure board with stbStop (could be an equivalent stop to a meta stop or the first stop in the list)
    if (this.Controller.Timetable.selectedInput === 'stop') {
      if (!params?.extId) {
        return journey.stbStop;
      }

      return journey.resolvedLocList.find(location => location.extId === params.extId);
    }

    if (this.Controller.Timetable.selectedInput === 'line') {
      var location = this.Controller.Timetable.instance.getLocation('S')
      if (location?.lid) {
        return location;
      }
      return journey.stbStop;
    }

    return null;
  },

  renderTimetableTable: function (params) {
    console.log("+++ renderTimetableTable +++", params);
    var me = this;
    var target = Hafas("[data-result-container='timetable']");
    var model = {
      dataAttribute: "data-overlay-target='loader_schedules'",
      label: Hafas.Modules.i18n.get('Timetable.t_N_allDepartures')
    };
    var hasResult = true;
    var template = "Timetable_TplDirectionResults";
    if (typeof params != "undefined" && params.length > 0) {
      model = params[0].directionsList[0];
    } else {
      template = "Timetable_TplDirectionNoResults";
      hasResult = false;
    }

    var lineId = me.Controller.Timetable.instance.getLineId();
    var product = Hafas.bind(me.Controller.Timetable.getProduct, me)();
    me.Controller.Timetable.result = model;
    me.Controller.Timetable.result.prodResolved = product;
    me.Controller.Timetable.result.dirText = Hafas.bind(me.Controller.Timetable.getDirectionText, me)();

    Hafas("#HFS_TimetableStationSelectBox_Option_0").setAttribute("aria-disabled", true);

    Hafas.Modules.Render.render({
      file: 'timetable.result.html',
      target: target,
      template: template,
      model: model
    }, Hafas.bind(function (html) {
      if (hasResult) {
        Hafas.ps.pub('/gui/common/showLoader', [false]);
        var location = me.Controller.Timetable.instance.getLocation("S");
        if (location.hasOwnProperty('extId')) {
          Hafas.bind(me.Controller.Timetable.setActiveStation, me)(location.extId);
        }
      }
      if (Hafas("#HFS_TimtableTabsWrapper")) {
        var callback = function () {
          Hafas.ps.pub('/app/events/resize');
        };
        Hafas.Core.newType('HafasSegmentedControl', {holder: 'HFS_TimtableTabsWrapper', callback: callback}).initiate();
      } else {
        Hafas.ps.pub('/app/events/resize');
      }
      // Hafas.ps.pub('/gui/common/showLoader', [false, 'loader_schedules']);
      Hafas.Util.gui.setVisibility(Hafas("[data-overlay-target='loader_schedules']"), false);
    }, this));
  },

  selectStation: function () {
    var selectedLocation = this.Controller.Timetable.instance.getLocation('S');
    // TODO: Die Location bereits vollständig im Modul in den Object Keeper werfen?
    var locKey = Hafas.Modules.Render.objectKeeper.keep(selectedLocation);
    Hafas.ps.pub('/sq/searchFromOtherContext', [locKey, "dep"]);
    Hafas.ps.pub('/app/events/closeResults', [{}]);
    Hafas.ps.pub('/GUI/results/details/hide', [{}]);
  },

  jumpinTimetable: function () {
    var dirTxt = Hafas.bind(this.Controller.Timetable.getDirectionText, this)();
    var lineId = this.Controller.Timetable.instance.getLineId();
    Hafas.ps.pub('/timetable/linesearch/jumpin', [{lineId: lineId, dirText: dirTxt, dirLocation:null}]);
  },

  setSelectedInput: function (input) {
    this.Controller.Timetable.selectedInput = input;
  },

  getSelectedInput: function () {
    return this.Controller.Timetable.selectedInput;
  },

  setDirectionText: function (txt) {
    this.Controller.Timetable.currentDirection = txt;
  },

  getDirectionText: function () {
    var txt = "";
    if (this.Controller.Timetable.hasOwnProperty('currentDirection')) {
      txt = this.Controller.Timetable.currentDirection;
    }
    return txt;
  },

  setLocationInfo: function (result) {
    this.Controller.Timetable.currentLocInfo = result;
  },

  getLocationInfo: function () {
    return this.Controller.Timetable.currentLocInfo || null;
  },

  setLineMatchResult: function (line) {
    this.Controller.Timetable.currentLine = line;
  },

  getLineMatchResult: function () {
    return this.Controller.Timetable.currentLine || null;
  },

  setProduct: function (product) {
    this.Controller.Timetable.currentProduct = product;
  },

  getProduct: function () {
    return this.Controller.Timetable.currentProduct || null;
  },

  setLineDetailsResult: function (result) {
    // console.log("+++ setLineDetailsResult +++", result);
    this.Controller.Timetable.currentLineResult = result;
  },

  getLineDetailsResult: function () {
    var lineResult = this.Controller.Timetable.currentLineResult;
    return lineResult;
  },

  getDirectionJourney: function (params) {
    var journey = null;
    var lineResult = this.Controller.Timetable.currentLineResult;
    for(var dirIdx = 0; dirIdx < lineResult.directions.length; dirIdx++) {
      var currentDirection = lineResult.directions[dirIdx];
      if(currentDirection.txt === params.direction || currentDirection.jny?.dirText === params.direction) {
        journey = currentDirection.jny;
      }
    }
    return journey;
  },

  // Übergabeparameter: Ein Richtungstext und eine Linie
  // Festgelegt wird daraus das Richtungsflag für die übergebene Richtung
  // Wird benötigt für externen Einsprung über URL-Parameter
  selectDirectionFlag: function(params) {
    var dirText = params.dirText;
    var line = params.line;
    for(var dirIdx = 0; dirIdx < line.directions.length; dirIdx++) {
      if(line.directions[dirIdx].txt == dirText) {
        this.Controller.Timetable.instance.setDirectionFlag(line.directions[dirIdx].flg);
        break;
      }
    }
  },

  GUI: {
    form: {
      toggleFormSelectboxes: function (params) {
        var idList = params.idL;
        for (var i = 0; i < idList.length; i++) {
          var ele = Hafas("#" + idList[i]);
          if (ele) {
            Hafas.Util.gui.setVisibility(ele, params.show);
          }
        }
      },
      toggleLoadingView: function (params) {
        var currentView = Hafas.bind(this.Controller.Timetable.getSelectedInput, this)();
        var boolval = params.toggle;
        if (params.hasOwnProperty('ids')) {
          for (var i = 0; i < params.ids.length; i++) {
            Hafas.Util.gui.setVisibility(Hafas("#" + params.ids[i]), boolval);
          }
        } else {
          Hafas.Util.gui.setVisibility(Hafas("#HFS_TimetableIndex_Overlay"), boolval);
          Hafas.Util.gui.setVisibility(Hafas("#HFS_LineDirectionWrapper"), boolval);
          Hafas.Util.gui.setVisibility(Hafas("#HFS_TimetableSubmitWrapper"), boolval);
          if (currentView === "line") {
            Hafas.Util.gui.setVisibility(Hafas("#HFS_LineStopWrapper"), boolval);
          } else if (currentView == "stop") {
            Hafas.Util.gui.setVisibility(Hafas("#HFS_LineSelectionWrapper"), boolval);
          }
        }
        Hafas.ps.pub('/app/events/resize');
      }
    },
    common: {
      showLoader: function (bool, target) {
        var loaderOverlay = Hafas("[data-overlay='loader']", true);
        for (var i = 0; i < loaderOverlay.length; i++) {
          if (bool) {
            loaderOverlay[i].style.display = "block";
          } else {
            loaderOverlay[i].style.display = "none";
          }
        }
        // Wenn es mehrere Loader in der view gibt
        if (target) {
          for (var i = 0; i < loaderOverlay.length; i++) {
            loaderOverlay[i].style.display = "none";
          }
          var targetC = Hafas("[data-overlay-target='" + target + "']");
          if (targetC) {
            targetC.style.display = "block";
          }
        }
      }
    }
  },

  /**
   * Redraw the current line, e.g. when changing the color scheme.
   */
  redrawLine: function () {
    var ttController = this.Controller.Timetable;
    var journey = Hafas.bind(ttController.getDirectionJourney, this)({direction: ttController.currentDirection});
    if (journey) {
      Hafas.bind(ttController.clearMap, this)();
      var params = {product: ttController.currentLineResult.prodResolved, stopList: journey.resolvedLocList};
      Hafas.bind(ttController.drawLineToMap, this)(params);
    }
  },

  // TODO: in Map controller auslagern, weiß aber noch nicht wie

  drawLineToMap: function (params) {
    // console.log("+++ drawLineToMap +++", params);
    Hafas.ps.pub('/map/closeAllToolboxItems', []);
    this.Controller.Timetable.mapContent.polylines = [];
    if (Hafas.Config.Switches.useLineSearch) {
      Hafas.bind(this.Controller.LineSearch.hideLineDetails, this.Controller.LineSearch)();
    }
    var stopList = params.stopList;
    var product = params.product;

    var map = this.Controller.Map.instance;
    var polylineData = Hafas.bind(this.Controller.Timetable.createPolylineFromStopList, this)(stopList);

    var polylineColors = product.icoResolved;
    // Get current color scheme. Use "light" as fallback if server sent no dark mode colors.
    var isDark = Hafas.Core.getColorScheme() === 'dark';
    var currentColorScheme = isDark && polylineColors.dark ? 'dark' : 'light';

    var polylineParams = {
      color: polylineColors[currentColorScheme].bg,
      zIndex: 120,
      border: Hafas.Config.Maps.useLineBorders,
      borderColor: Hafas.Config.Maps.LINE_BORDER_COLOR,
      useArrows: true,
      opacity: 1,
      width: 5
    };

    this.Controller.Timetable.mapContent.polylines.push(Hafas.Util.maps.showHCIPolyline(polylineData, map, polylineParams));

    var showFlyoutHint = ", " + Hafas.Modules.i18n.get('Map.a11y.t_N_showFlyoutHint');
    var startEndStopHint = "";
    for (var i = 0; i < stopList.length; i++) {
      if (i < stopList.length - 1) {
        startEndStopHint = Hafas.Modules.i18n.get('Map.a11y.t_N_startStop');
      } else {
        startEndStopHint = Hafas.Modules.i18n.get('Map.a11y.t_N_endStop');
      }
      if (stopList[i].crd) {
        var loc = stopList[i];
        var icon = product.icoResolved;
        currentColorScheme = isDark && icon.dark ? 'dark' : 'light';
        var html = "<span class='hfs_stationName' data-render-element='loc_label' data-extId='" + loc.extId + "'><span class='lyr_srOnly'>" + startEndStopHint +  "</span>" + loc.name + "<span class='lyr_srOnly'>" + showFlyoutHint + "</span></span>";
        this.Controller.Timetable.mapContent.locations.push(Hafas.Util.maps.showHCILocation(loc, map, {
          type: "container",
          html: html
        }, false, {backgroundColor: icon[currentColorScheme].bg}));

        this.Controller.Timetable.mapContent.locations.push(Hafas.Util.maps.showHCILocation(loc, map, null, false, {backgroundColor: icon[currentColorScheme].bg}));
      }
    }

    var stationLabels = Hafas("#HFS_PageMap .hfs_stationName", true);

    // Labels auf der Karte bis auf Start- und Endpunkt ausblenden
    for (var j = 0; j < stationLabels.length; j++) {
      if (j != 0 && j != stationLabels.length - 1)
        stationLabels[j].parentNode.style.display = "none";
    }

    map.centerToContent(this.Controller.Timetable.mapContent.polylines[0]);
  },

  createPolylineFromStopList: function (stopList) {
    var coodList = [];
    for (var i = 0; i < stopList.length; i++) {
      if (stopList[i].crd) {
        var stop = stopList[i];
        coodList.push(Hafas.Util.geo.hciCrdToHafasCoord(stop.crd));
      }
    }
    return coodList;
  },

  setActiveStation: function (extId) {
    var currentStation = this.Controller.Timetable.instance.getStopFromList(extId);

    var mapStationLabels = Hafas("#HFS_PageMap .hfs_active", true);
    for (var i = 0; i < mapStationLabels.length; i++) {
      mapStationLabels[i].removeClassName('hfs_active');
      mapStationLabels[i].parentNode.style.display = "none";
    }

    try {
      var mapNodes = Hafas('[data-render-element="loc_label"][data-extId="' + extId + '"]', true);
      for (var i = 0; i < mapNodes.length; i++) {
        mapNodes[i].parentNode.style.display = "";
        mapNodes[i].addClassName("hfs_active");
      }
    }
    catch (e) {
      Hafas.logger.error(Hafas.logger.ERROR_TYPES.JS, "timetables.setActiveStation", "", e);
    }
    // Flyout zu der ausgewählten Station anzeigen
    Hafas.ps.pub('/map/clickOnLocation', [this.Controller.Map.instance, currentStation, null, {},{lazyLoadLines: false}, false]);
    Hafas.bind(this.Controller.Timetable.zoomMapToStation, this)(currentStation);
  },

  zoomMapToStation: function (station) {
    function getCoordFromStation(s) {
      return Hafas.Core.newType("hafasCCoord", {
        lat: s.crd.y,
        lon: s.crd.x
      })
    }

    this.Controller.Map.instance.centerToGeo(getCoordFromStation(station), Hafas.Config.Maps.searchPredefinedZoom);
  },

  clearMap: function () {
    var map = this.Controller.Map.instance;
    for (var i = 0; i < this.Controller.Timetable.mapContent.polylines.length; i++) {
      map.hideContent(this.Controller.Timetable.mapContent.polylines[i]);
      map.removeContent(this.Controller.Timetable.mapContent.polylines[i]);
    }

    for (var i = 0; i < this.Controller.Timetable.mapContent.locations.length; i++) {
      map.hideContent(this.Controller.Timetable.mapContent.locations[i]);
      map.removeContent(this.Controller.Timetable.mapContent.locations[i]);
    }

    this.Controller.Timetable.mapContent.polylines = [];
    this.Controller.Timetable.mapContent.locations = [];
  },

  closeView: function (histData) {
    // console.log("+++ closeView +++", histData);
    switch (histData.view) {
      case "index":
        Hafas.ps.pub('/GUI/form/hide', [{}]);
        break;
      case "result":
        Hafas.ps.pub('/app/events/closeResults', [{}]);
        Hafas.ps.pub('/GUI/results/details/hide', [{}]);
        break;
      case "map":
        Hafas.ps.pub('/GUI/map/hide', []);
        break;
      case "editSmartLocations":
        Hafas.ps.pub('/favorites/smartLocations/closeView');
        break;
    }

  },
  restoreView: function (histData) {
    // console.log("+++ restoreView +++", histData);
    var view = histData.view;
    switch (view) {
      case "index":
        // Hafas.bind(this.Controller.Timetable.cleanup, this)();
        Hafas.ps.pub('/map/closeAllToolboxItems');
        Hafas.bind(this.Controller.Timetable.clearMap, this)();
        Hafas.ps.pub('/app/events/closeResults', [{}]);
        Hafas.bind(this.Controller.Timetable.index, this)();
        Hafas.ps.pub('/GUI/form/show', [{}]);
        break;
      case "result":
        if (histData.data.hasOwnProperty('lineId')) {
          this.Controller.Timetable.instance.setLineId(histData.data.lineId);
        }
        if (histData.data.hasOwnProperty('dirText')) {
          Hafas.bind(this.Controller.Timetable.setDirectionText, this)(histData.data.dirText);
        }
        Hafas.ps.pub('/timetable/jumpin');
        break;
      case "editSmartLocations":
        Hafas.ps.pub('/favorites/smartLocations/edit', [{locKey: Hafas.Modules.Render.objectKeeper.keep(histData.data.loc), target: this.smartLocationsContainer}]);
        break;
    }
  },
  cleanup: function () {
    // console.log("+++ cleanup +++");
    Hafas.ps.pub('/map/closeAllToolboxItems');
    Hafas.bind(this.Controller.Timetable.clearMap, this)();
    Hafas.bind(this.Controller.Timetable.deleteStopInput, this)();
    Hafas.bind(this.Controller.Timetable.deleteLineInput, this)();

    // GUI Funktionen aus Controller.App.events.closeResults übernommen (zu prüfen)
    Hafas.ps.pub('/GUI/results/details/hide', [{}]);
    Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
    Hafas.ps.pub('/GUI/results/all/hide', [{}]);

    // If we have smart locations, close the edit view
    if (Hafas.Config.Switches.useSmartLocations === true) {
      Hafas.ps.pub('/favorites/smartLocations/closeView');
    }

    Hafas.ps.pub('/GUI/results/overview/removeActive', [{arrayIdx: null}]);
    Hafas.ps.pub('/GUI/results/additional/hideAll');
    Hafas.ps.pub('/GUI/results/resize', [{container: this.resultOverviewContainer, appcontext: this.appContext}]);
  },

  /**
   * clears all input data (including options)
   *
   * @method
   */
  clearInput: function () {
    // Entferne aktuellen History-Eintrag, da nachfolgend über switchContext ein neuer hinzu kommt
    Hafas.Modules.History.removeCurrentStep("index", () => {
      Hafas.ps.pub('/app/switchContext', [{context: 'Timetable', method: 'index'}]);
    });

    Hafas.bind(this.Controller.Timetable.deleteStopInput, this)(true);
    Hafas.bind(this.Controller.Timetable.deleteLineInput, this)(true);


    Hafas.Modules.a11y.Announce.assertive(Hafas.Modules.i18n.get('common.menu.t_N_clearInput_success'));
  }
};
